import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS,provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared-resources/shared.module';
import { HomeComponent } from './shared-resources/components/home/home.component';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast'; 
import { AccordionModule } from 'primeng/accordion';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationModalComponent } from './shared-resources/components/confirmation-modal/confirmation-modal.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { InterceptorOneService } from './shared-resources/msal/interceptor/auth.interceptor';
import { SessionExpirationAlertComponent } from './session-expiration-alert/session-expiration-alert.component';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function MSALInstanceFactory() : IPublicClientApplication{
  return new PublicClientApplication({
    auth: {
      clientId: environment.appId,
      redirectUri: environment.redirectUrl,
      authority: environment.authority,
    },
    cache: {
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: isIE,
		},
    system: {
      allowNativeBroker: false, // Disables native brokering support
  }
  })
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.graphEndPoint, environment.scopes);
  protectedResourceMap.set(environment.microsoftApiUrl, environment.portalScope);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,    
    ConfirmationModalComponent, SessionExpirationAlertComponent
  ],bootstrap: [AppComponent],
  imports: [FormsModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastModule,
    DialogModule,
    NgxSpinnerModule,
    AccordionModule,
    CheckboxModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    MsalModule,
    NgxSpinnerModule.forRoot(),
    ReactiveFormsModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    MsalInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorOneService,
      multi: true
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  
})
export class AppModule { }
